module.exports = __webpack_public_path__ + "static/media/41.91178da8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/41.jpg
// module id = 250
// module chunks = 0